export default __webpack_public_path__ + "static/media/neet_important_icon.620ede2b.svg";